<template>
    <div style="width: 100%">
        <v-card elevation="0">
            <div class="d-flex flex-row">
                <v-card-title
                    class="d-flex grow"
                    v-if="$vuetify.breakpoint.mdAndUp"
                >
                    <h3 class="ma-0 font-weight-light">
                        Seguimiento Gestiones
                    </h3>
                </v-card-title>
            </div>
            <!-- <v-divider class="test mb-2"></v-divider> -->
            <v-card flat>
                <div style="width: 100%">
                    <div class="px-2">
                        <v-text-field
                            class="px-2"
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Buscar"
                            single-line
                            hide-details
                        ></v-text-field>
                    </div>
                    <v-data-table
                        :headers="headers"
                        :items="gestiones"
                        :footer-props="footersProps"
                        :page.sync="page"
                        :items-per-page="10"
                        :options.sync="options"
                        :server-items-length="totalEntries"
                        class="elevation-0 px-2"
                        :loading="loading"
                        :hide-default-footer="loading"
                    >
                        <template v-slot:item.cliente.nombre="{ item }">
                            <div class="font-weight-medium">
                                {{
                                    item.cliente.nombre
                                        ? item.cliente.nombre
                                        : 'Sin asignar'
                                }}
                            </div>
                        </template>
                        <template
                            v-if="$store.getters['login/hasManagerPermission']"
                            v-slot:item.comercial="{ item }"
                        >
                            <div>
                                {{ getNombreComercial(item) }}
                            </div>
                        </template>
                        <template v-slot:item.fechaContacto="{ item }">
                            <div class="font-italic">
                                {{ formatDate(item.fechaContacto) }}
                            </div>
                        </template>
                        <template v-slot:item.updatedOn="{ item }">
                            <div class="font-italic">
                                {{ formatDate(item.updatedOn) }}
                            </div>
                        </template>
                        <template v-slot:item.showGestion="{ item }">
                            <v-btn
                                color="#2c3a5c"
                                :disabled="loading"
                                @click="viewGestion(item)"
                                icon
                            >
                                <v-icon>mdi-eye</v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:item.upfrontTotal="{ item }">
                            {{ getUpfrontPorcentual(item) }} €
                        </template>
                    </v-data-table>
                </div>
            </v-card>
        </v-card>
        <AdministrationForm />
    </div>
</template>
    
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import AdministrationForm from '../../ComercialTeletrabajo/TtForm/AdministrationForm.vue';

export default {
    name: 'TablaGestionesLiq',
    components: {
        AdministrationForm,
    },
    data: () => ({
        headers: [
            { text: 'Cliente', value: 'cliente.nombre', sortable: false },
            {
                text: 'Actualizado',
                value: 'updatedOn',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Gestión',
                value: 'servicio.name',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Ver gestión',
                value: 'showGestion',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Upfront',
                value: 'upfrontTotal',
                align: 'center',
                sortable: false,
            },
        ],
        footersProps: {
            disableItemsPerPage: false,
            itemsPerPageOptions: [10],
        },
        gestiones: [],
        options: {},
        selectedAtencion: null,
        page: 1,
        totalEntries: 0,
        loading: false,
        isOpenViewDialog: false,
        search: null,
        isOpenDeleteDialog: false,
    }),
    props: {
        currentDate: Date,
    },
    computed: {
        ...mapState('areaPersonal/calculadora', {
            selectedComercial: (state) => state.selectedComercial,
            father: (state) => state.dateAtencionForm.father,
        }),
        ...mapState('teletrabajo', {
            comerciales: (state) => state.Comerciales,
        }),
        ...mapGetters('login', {
            hasManagerPermission: 'hasManagerPermission',
        }),
    },
    methods: {
        getUpfrontPorcentual(item) {
            // Get is_active item.servicio.upfrontHistory
            const upfrontHistory = item.servicio.upfrontHistory.find(
                (upfront) => upfront.isActive
            );

            return upfrontHistory
                ? (
                      item.comercial.currentReward.amount *
                      0.01 *
                      upfrontHistory.upfront
                  ).toFixed(2)
                : 0;
        },
        ...mapActions({
            fetchGestiones: 'areaPersonal/calculadora/fetchGestiones',
        }),
        formatDate(date) {
            let mondate = new Date(date);
            let options = {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false,
                timeZone: 'Europe/Madrid',
            };
            return new Intl.DateTimeFormat('es-ES', options).format(mondate);
        },
        viewGestion(atencion) {
            let AdministrationForm = {
                isOpen: true,
                isSaving: false,
                isEditable: false,
                form: { ...atencion, gestion: atencion.servicio },
            };

            this.$store.commit(
                'teletrabajo/AdministrationForm',
                AdministrationForm
            );
        },
        getNombreComercial(item) {
            let nombre = 'Sin asignar';
            if (item.comercial) {
                if (this.comerciales) {
                    let comercial_find = this.comerciales.find(
                        (comercial) => comercial.id === item.comercial.id
                    );
                    if (comercial_find) {
                        nombre = comercial_find.nombreCompleto;
                    }
                }
            }
            return nombre;
        },
        async update() {
            this.loading = !this.loading;
            try {
                let params = {
                    ...{
                        mes_year_updated_on: `${this.currentDate.getFullYear()}-${
                            this.currentDate.getMonth() + 1
                        }`,
                    },
                    ...this.options,
                };

                if ('itemsPerPage' in params) {
                    if (this.hasManagerPermission && this.selectedComercial)
                        params.comercial = this.selectedComercial.id;
                    if (this.search) params.search = this.search;
                    let data = await this.fetchGestiones(params);
                    this.gestiones = data.results;
                    this.totalEntries = data.count;
                }
            } catch (err) {
                console.log(err.message);
            }
            this.loading = !this.loading;
            // setTimeout(() => (this.loading = !this.loading), 200);
        },
    },
    watch: {
        options: {
            immediate: true,
            handler: async function (newVal, oldVal) {
                if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                    return;
                }

                this.update();
            },
        },
        selectedComercial() {
            // this.options = {};
            this.page = 1;
            this.update();
        },
        currentDate() {
            this.update();
        },
        search(newVal, oldVal) {
            let prev = newVal;
            setTimeout(() => {
                if (prev == this.search) this.update();
            }, 200);
        },
    },
    mounted() {
        if (this.$store.getters['login/hasManagerPermission']) {
            this.headers.splice(1, 0, {
                text: 'Comercial',
                value: 'comercial',
                align: 'center',
            });
        }
    },
};
</script>

<style>
</style>